import axios from 'axios';
import { getAuthApiUrl } from '../config';

export const parentAppAuthService = {
    // Step 1: Request OTP
    requestOtp: async (contactNumber) => {
        const response = await axios.post(`${getAuthApiUrl()}/request-otp`, { contactNumber });
        return response.data;
    },
    // Step 2: Verify OTP
    verifyOtp: async (contactNumber, otp) => {
        const response = await axios.post(`${getAuthApiUrl()}/verify-otp`, { contactNumber, otp });
        return response.data; // contains token and students array
    }
};
